// Types
import { FETCH_SERVICE_STATE } from 'constants/types';

// Helpers
import { apiRequest } from 'helpers/apiClient';

export const fetchServiceState = (guid) => dispatch => {
    return apiRequest('/api/v1/adminstatus/servicestate').then(result => {
        if (result.ok) {
            return dispatch({ type: FETCH_SERVICE_STATE, payload: result.data });
        }
        // Både !ok-status og nettverksfeil behandles som "utilgjengelig".
        const serviceState = {
            state: "unavailable",
            messageHeader: "Tjenesten er ikke tilgjengelig",
            messageBody: "Tjenesten er midlertidig utilgjengelig grunner planlagt vedlikehold.\nVennligst prøv igjen om noen minutter."
        };
        return dispatch({ type: FETCH_SERVICE_STATE, payload: serviceState });
    });
}
